






















































































import {Component} from 'vue-property-decorator';
  import {Getter} from "vuex-class";
  import ProxySettingsFilter from "@/components/Settings/ProxySettings/ProxySettingsFilter.vue";
  import {ProxySettingItem} from "@/store/settings/proxy_settings/types";
  import {ScrollButton} from "wings-ui-components";
  import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
  import draggable from 'vuedraggable'

  @Component({components: {draggable, ProxySettingsFilter, ScrollButton}})
  export default class ProxySettings extends BaseItemsPage<ProxySettingItem> {
    @Getter("proxySettings") proxySettingResponse!: ProxySettingItem[];

    is_show_filter = false;
    currentSort = 'id';
    currentSortOrder = 'desc';
    tableFields = [
      'name',
      'host',
      'port'
    ];

    getData(): ProxySettingItem[] {
      return this.proxySettingResponse;
    }
  }
